const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const StunnedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.handle = 'stunned';
	condition.duration = duration;
	condition.ConditionClass = StunnedCondition;

	const extant = BattleCalc.getCondition( owner, 'stunned' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};

StunnedCondition.fromCopy = function(cState, owner, instigator, battleState) {
	const elapsed = Date.now() - cState.startTime;
	const remainingDuration = Math.max(0, cState.duration - elapsed);
	return StunnedCondition(instigator, owner, battleState, remainingDuration);
};

module.exports = StunnedCondition
